import Vue from 'vue'
import '@/vendor-components'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import companyService from '@/services/company.service'
import accountService from '@/services/account.service'
import roleService from '@/services/role.service'
import serviceService from '@/services/service.service'
import dialogService from '@/services/dialog.service'
import makerService from '@/services/maker.service'
import supplierService from '@/services/supplier.service'
import siteService from '@/services/site.service'
import itemCategoriesService from '@/services/itemCategories.service'
import itemCategoryLevelsService from '@/services/itemCategoryLevels.service'
import mouseAccount from '@/services/mouseAccount.service'
import announcementService from '@/services/announcement.service'
import '@/global-components'

// Global Styles
import './assets/variables.scss'

Vue.config.productionTip = false

Vue.config.errorHandler = err => {
  console.error(err)
  alert('エラーが発生しました。')
}

new Vue({
  router,
  store,
  company: companyService,
  account: accountService,
  mouseAccount: mouseAccount,
  role: roleService,
  service: serviceService,
  maker: makerService,
  supplier: supplierService,
  site: siteService,
  dialog: dialogService,
  itemCategories: itemCategoriesService,
  itemCategoryLevels: itemCategoryLevelsService,
  announcement: announcementService,
  render: h => h(App),
}).$mount('#app')
